export enum ClaimType
{
    Property = 0,
	Auto = 1,
	AutoGlass = 2,
	Other = 3,
	GeneralLiability = 4
}

export class Claim
{
    websiteId: string = "";
    id: string = "";
    type: ClaimType = ClaimType.Property;
    policyNumber: string = "";
    claimNumber: string = "";
    email: string = "";
    lossDate: Date = new Date();
    policyName: string = "";
    firstName: string = "";
    lastName: string = "";
    line1 :string = "";
    city :string = "";
    state :string = "";
    zipCode :string = "";
    primaryPhone :string = "";
    altPhone :string = "";
    damageEstimation :string = "";
    explanation :string = "";
    lossLocation: string = "";
    bestContactName: string = "";
    bestContactPhone: string = "";
    bestContactAltPhone: string = "";
    remarks: string = "";
    additionalAnswers: {[key:string]: string} = {};
}

export class AutoClaimReport extends Claim
{
    _t:string = "AutoClaim";
    policyHolderVehicleYear:string = "";
    policyHolderVehicleMake:string = "";
    policyHolderVehicleModel:string = "";
    policyHolderVehicleVIN:string = "";
    isVehicleDrivable:boolean = false;
    didAirbagsDeploy:boolean = false;
    pointOfImpact:string = "";
    otherPropertyDamage:string = "";
    otherPropertyDescription:string = "";
	otherPropertyVehicleYear:string = "";
	otherPropertyVehicleMake:string = "";
	otherPropertyVehicleModel:string = "";
	otherPropertyVehicleVIN:string = "";
    otherPropertyOwnersName:string = "";
    otherPropertyOwnersAddress:string = "";
    otherPropertyOwnersPhone:string = "";
    otherPropertyOwnersAltPhone:string = "";
    otherPropertyOwnersCompAgency:string = "";
    otherPropertyVehicleDriverName:string = "";
    otherPropertyVehicleDriverAddress:string = "";
    otherPropertyDamageDescription:string = "";
    otherPropertyDamageAmount:string = "";
    otherPropertyDamageLocation:string = "";
    areInjuries:boolean = false;
    areWitnessPassengers:boolean = false;
    policyHolderDriver:string = "";
    driverName:string = "";
    vehicleLocation:string = "";
    otherPropertyOwnersPolicy:string = "";
}

export class GeneralLiabilityClaimReport extends Claim
{
	isLawsuitFiled: boolean = false;
	occuranceType: string = "";
	propertyDescription: string = "";
	propertyOwnerName: string = "";
	propertyOwnerAddress: string = "";
	propertyOwnersPrimaryPhone: string = "";
	propertyOwnersAlternatePhone: string = "";
	propertyOwnersEmail: string = "";
	propertyDamageAmount: string = "";
	injuryDescription: string = "";
	injuredPersonsName: string = "";
	injuredPersonsAddress: string = "";
	injuredPersonsPrimaryPhone: string = "";
	injuredPersonsAlternatePhone: string = "";
	injuredPersonsEmail: string = "";
	areWitnesses: boolean = false;
	witnessName: string = "";
	witnessAddress: string = "";
	witnessPrimaryPhone: string = "";
	witnessAlternatePhone: string = "";
	witnessEmail: string = "";

}
